import './modal.scss'
import { PropsWithChildren, useCallback, useEffect } from 'react'
import classnames from 'classnames'

import CloseIcon from '@mui/icons-material/Close'

interface ModalProps extends PropsWithChildren {
  onClose?: () => void
  isOpen: boolean
}
//TODO - only fades in, work on fade out
export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen && !document.body.classList.contains('no-scroll')){
      document.body.classList.add('no-scroll')
    }
    return () => document.body.classList.remove('no-scroll')
  }, [isOpen])

  const onCloseClick = useCallback(() => {
    onClose?.()
    document.body.classList.remove('no-scroll')
  }, [onClose])


  return (
    <div className={classnames({ 'coin-modal': true, open: isOpen, 'closed': !isOpen})}>
      <div className="coin-modal-content">
        <div className="header col-12">
          <div className="close-btn" onClick={onCloseClick}>
            <CloseIcon />
          </div>
        </div>
        { children }
      </div>
      <div className="coin-modal-background" />
    </div>
  )
}